import $ from 'jquery';
import getPositionY from '../about/getPositionY';
/**
 * caculate article scrollY
 */
const articlePosition = () => {
	const array = [];
	$('.storybg').each((i) => {
		array.push(
			getPositionY($(`.article-block.-story${i + 1}`)),
		);
	});
	return array;
};

export default articlePosition;



// WEBPACK FOOTER //
// ./src/js/about/articlePosition.js